import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=7f1bf2c4&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"
import style0 from "./Panel.vue?vue&type=style&index=0&id=7f1bf2c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1bf2c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f1bf2c4')) {
      api.createRecord('7f1bf2c4', component.options)
    } else {
      api.reload('7f1bf2c4', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=7f1bf2c4&scoped=true", function () {
      api.rerender('7f1bf2c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerServiceChat/Panel.vue"
export default component.exports